export default {
      id: "ic_twitter2-usage",
      viewBox: "0 0 20 20",
      url: "/" + "images/icons.3.109.2.svg#ic_twitter2-usage",
      toString: function () {
        return this.url;
      }
    }